import {
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from '@domain/types';

export const phoneStep: ServiceRequestStep = {
  type: ServiceRequestStepType.CONTACT,
  inSummary: true,
  title: `quote:phone.title`,
  additionalCopy: `quote:additionalCopy.phone.title`,
  segmentEvent: `Phone Number Filled in `,
  fields: [
    {
      type: ServiceRequestFieldType.INPUT,
      summaryTitle: `form:placeholder.phone`,
      props: {
        name: `project.user.phone`,
        placeholder: `quote:phone.phone.placeholder`,
        validation: [`isRequired`],
      },
    },
    {
      type: ServiceRequestFieldType.TEXTAREA,
      summaryTitle: `quote:phone.comment.summaryTitle`,
      props: {
        name: `project.user.phone_comment`,
        placeholder: `quote:phone.comment.placeholder`,
      },
    },
  ],
};
